import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { isCurrentPath } from '@openclassrooms/routing';
import Typography from '@classify/react-core-components/Typography';
import MainHeaderNavigationLink from '../MainHeaderNavigationLink';
import StyledListItem from './StyledListItem';
import StyledListItemText from './StyledListItemText';
interface Props {
  link: {
    path: any;
    content: any;
    dataEvent?: 'string';
    shouldUseHref?: boolean;
    shouldBeDisplayed?: boolean;
    dataTestId?: string;
    linkAttributes?: {};
  };
  onClickAction?: () => void;
  isSubMenuItem?: boolean;
}
const LinkListItem = t0 => {
  const $ = _c(20);
  const {
    link,
    onClickAction,
    isSubMenuItem
  } = t0;
  const {
    path,
    content,
    dataEvent,
    linkAttributes
  } = link;
  let t1;
  if ($[0] !== dataEvent || $[1] !== linkAttributes || $[2] !== onClickAction) {
    t1 = {
      dataEvent,
      onClickAction,
      linkAttributes
    };
    $[0] = dataEvent;
    $[1] = linkAttributes;
    $[2] = onClickAction;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const linkProps = t1;
  let t2;
  if ($[4] !== link.path || $[5] !== linkProps) {
    t2 = forwardRef((props, ref) => <div ref={ref}><MainHeaderNavigationLink {...props} path={link.path} {...linkProps} /></div>);
    $[4] = link.path;
    $[5] = linkProps;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const ListItemComponent = t2;
  const t3 = isSubMenuItem ? 0 : 1;
  let t4;
  if ($[7] !== t3) {
    t4 = {
      my: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isCurrentPath(path, true) ? "palette.primary.main" : null;
  let t6;
  if ($[9] !== t5) {
    t6 = {
      color: t5
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== content) {
    t7 = <Typography variant="body" component="span">{content}</Typography>;
    $[11] = content;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <StyledListItemText sx={t6} primary={t7} />;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== ListItemComponent || $[17] !== t4 || $[18] !== t8) {
    t9 = <StyledListItem component={ListItemComponent} button={true} sx={t4}>{t8}</StyledListItem>;
    $[16] = ListItemComponent;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default LinkListItem;